module.exports = __webpack_public_path__ + "img/1589.8c5acacd.png";